import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import moment from "moment";
import AlertBox from "../AlertBox";
import { useTicketbyIdHooks } from "../../utils/ticket/TicketUlits";
import { createTikcetDetail } from "../../api/ticket";
import { useControlPermission } from "../../utils/ActionPermissionUtils";
import { ROLE_ASSIGN_TICKET } from "../../tools/tickettools";
import ResponsiveImageUploader from "../ResponsiveImageUploader";
import FormUpdateTicket from "./FormUpdateTicket";
import TroubleshootLocationSelect from "./TroubleshootLocationSelect";
import TroubleshootCauseSelect from "./TroubleshootCauseSelect";
import TroubleshootResolutionSelect from "./TroubleshootResolutionSelect";

export default function ModalReportTicketing({ show, id, onClose, onSuccess }) {
  let { hasAccess } = useControlPermission();
  const { data, fetched } = useTicketbyIdHooks({ id });
  const [alert, setAlert] = useState({ show: false, message: "", type: "" });
  let [loading, setLoading] = useState(false);
  let [attachments, setAttachments] = useState([]);

  let [form, setForm] = useState({ description: "", role: "", resolved: "false" });
  let [troubleshootForm, setTroubleshootForm] = useState({
    location: "",
    cause: "",
    resolution: "",
    manualLocation: "",
    manualCause: "",
    manualResolution: "",
  });

  const handleClose = () => {
    setAttachments([]);
    setAlert({ show: false, message: "", type: "" });
    setForm({ description: "", role: "", resolved: "false" });
    setTroubleshootForm({
      location: "",
      cause: "",
      resolution: "",
      manualLocation: "",
      manualCause: "",
      manualResolution: "",
    });
    onClose();
  };

  useEffect(() => {
    if (fetched) {
      setAttachments([
        { name: "Attachment #1", type: "attachment", attachment_url: "" },
        { name: "Attachment #2", type: "attachment", attachment_url: "" },
        { name: "Attachment #3", type: "attachment", attachment_url: "" },
      ]);
    }
  }, [data.role, fetched]);

  const submitData = (event) => {
    event.preventDefault();
    const isResolved = form.resolved === "true";
    const isTechnical = data.type === "technical";

    let formData = {
      role: form.role,
      description: form.description,
      resolved: form.resolved,
    };

    if (isResolved && isTechnical) {
      formData.troubleshoot_location_id = troubleshootForm.location || "";
      formData.troubleshoot_cause_id = troubleshootForm.cause || "";
      formData.troubleshoot_resolution_id = troubleshootForm.resolution || "";
      formData.troubleshoot_location_text = troubleshootForm.manualLocation || "";
      formData.troubleshoot_cause_text = troubleshootForm.manualCause || "";
      formData.troubleshoot_resolution_text = troubleshootForm.manualResolution || "";
    }

    if (attachments.length > 0) {
      formData.attachments = [];
      attachments.forEach((attach) => {
        if (attach.attachment_url !== "") {
          formData.attachments.push({
            type: attach.type,
            attachment_url: attach.attachment_url,
          });
        }
      });
    }

    updateTicket(formData);
  };

  const updateTicket = async (form) => {
    setLoading(true);
    try {
      let response = await createTikcetDetail(id, form);
      onSuccess(response.data.message);
      handleClose();
    } catch (error) {
      let message = "";
      if (error.response) {
        let { data } = error.response;
        message = data.message;
      } else {
        message = "Something Error Happened";
      }

      setAlert({ show: true, message, type: "danger" });
    }

    setLoading(false);
  };

  const onChangeImg = (type, image_url, index) => {
    let attachmentsData = [...attachments];
    attachmentsData[index].attachment_url = image_url;
    setAttachments([...attachmentsData]);
  };

  const updateTroubleshootForm = (field, value) => {
    setTroubleshootForm((prev) => {
      const updates = { [field]: value };
      if (field === "location") {
        updates.cause = "";
        updates.resolution = "";
        updates.manualLocation = "";
        updates.manualCause = "";
        updates.manualResolution = "";
      } else if (field === "cause") {
        updates.resolution = "";
        updates.manualCause = "";
        updates.manualResolution = "";
      }
      return { ...prev, ...updates };
    });
  };

  return (
    <Modal show={show} onHide={() => handleClose()} size="xl">
      <Modal.Header closeButton>
        <Modal.Title>Detil Tiket - {data.ticket_number}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col-lg-6">
            <table className="table table-sm table-bordered">
              <tbody>
                <tr>
                  <td>Nomor</td>
                  <td>{data.ticket_number || "-"}</td>
                </tr>
                <tr>
                  <td>Tgl. Dibuat</td>
                  <td>
                    {data.createdAt
                      ? moment.unix(data.createdAt).format("DD MMMM YYYY - HH:mm")
                      : "-"}
                  </td>
                </tr>
                <tr>
                  <td>Durasi</td>
                  <td>{data.total_time || "-"}</td>
                </tr>
                <tr>
                  <td>No. Pelanggan</td>
                  <td>{data.customer_number || "-"}</td>
                </tr>
                <tr>
                  <td>No. Registrasi</td>
                  <td>{data.registration_number || "-"}</td>
                </tr>
                <tr>
                  <td>Nama</td>
                  <td>{data.name || "-"}</td>
                </tr>
                <tr>
                  <td>Alamat</td>
                  <td>{data.address || "-"}</td>
                </tr>
                <tr>
                  <td>Telepon</td>
                  <td>{data.phone_number || "-"}</td>
                </tr>
                <tr>
                  <td>Prioritas</td>
                  <td>{data.priority || "-"}</td>
                </tr>
                <tr>
                  <td>Tipe</td>
                  <td>{data.type || "-"}</td>
                </tr>
                <tr>
                  <td>Penugasan</td>
                  <td>{data.role || "-"}</td>
                </tr>
                <tr>
                  <td>Ditugaskan Ke</td>
                  <td>{data.assigned_to_user?.name || "-"}</td>
                </tr>
                <tr>
                  <td>Tgl. Visit</td>
                  <td>
                    {data.visit_at
                      ? moment.unix(data.visit_at).format("DD MMMM YYYY - HH:mm")
                      : "-"}
                  </td>
                </tr>
                <tr>
                  <td>Sumber Tiket</td>
                  <td>{data.external_ticket_source || "Internal"}</td>
                </tr>
              </tbody>
            </table>
            {data.type === "technical" ? (
              <table className="table table-sm table-bordered mt-2">
                <tbody>
                  <tr>
                    <td colSpan="2" className="bg-light font-weight-bold">
                      Penyelesaian Masalah
                    </td>
                  </tr>
                  {data.troubleshoot_location ? (
                    <tr>
                      <td>Lokasi Masalah</td>
                      <td>
                        {data.troubleshoot_location.name}
                        {data.troubleshoot_location_text && (
                          <div className="mt-1">{data.troubleshoot_location_text}</div>
                        )}
                      </td>
                    </tr>
                  ) : (
                    <tr>
                      <td colSpan={2}>-</td>
                    </tr>
                  )}
                  {data.troubleshoot_cause ? (
                    <tr>
                      <td>Penyebab Masalah</td>
                      <td>
                        {data.troubleshoot_cause.name}
                        {data.troubleshoot_cause_text && (
                          <div className="mt-1">{data.troubleshoot_cause_text}</div>
                        )}
                      </td>
                    </tr>
                  ) : (
                    <tr>
                      <td colSpan={2}>-</td>
                    </tr>
                  )}
                  {data.troubleshoot_resolution ? (
                    <tr>
                      <td>Solusi</td>
                      <td>
                        {data.troubleshoot_resolution.name}
                        {data.troubleshoot_resolution_text && (
                          <div className="mt-1">{data.troubleshoot_resolution_text}</div>
                        )}
                      </td>
                    </tr>
                  ) : (
                    <tr>
                      <td colSpan={2}>-</td>
                    </tr>
                  )}
                </tbody>
              </table>
            ) : null}
            {(hasAccess("assign-ticket") || hasAccess("update-customer-crm-ticket")) && (
              <div className="mb-2">
                <FormUpdateTicket
                  ticket={data}
                  onSuccess={(msg) => {
                    onSuccess(msg);
                    handleClose();
                  }}
                />
              </div>
            )}

            <div className="card">
              <div className="card-body">
                <form onSubmit={(event) => submitData(event)}>
                  <h5>Form Laporan Tiket</h5>
                  <AlertBox {...alert} setAlert={setAlert} />
                  <div className="form-group">
                    <label>Deskripsi</label>
                    <textarea
                      className="form-control"
                      rows="5"
                      required
                      value={form.description}
                      onChange={(event) => setForm({ ...form, description: event.target.value })}
                    ></textarea>
                  </div>
                  <div className="form-group">
                    <label>Tugaskan ke:</label>
                    <select
                      className="form-control"
                      required
                      value={form.role}
                      onChange={(event) => setForm({ ...form, role: event.target.value })}
                    >
                      <option value="">-- Divisi --</option>
                      {Object.keys(ROLE_ASSIGN_TICKET).map((key, index) => (
                        <option value={key} key={index}>
                          {ROLE_ASSIGN_TICKET[key]}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Status Penyelesaian:</label>
                    <select
                      className="form-control"
                      required
                      value={form.resolved}
                      onChange={(event) => setForm({ ...form, resolved: event.target.value })}
                    >
                      <option value="false">Tidak terselesaikan</option>
                      <option value="true">Terselesaikan</option>
                    </select>
                  </div>
                  {data.type === "technical" && form.resolved === "true" ? (
                    <div className="mb-2">
                      <div className="card">
                        <div className="card-body">
                          <h5>Laporan Permasalahan</h5>
                          <TroubleshootLocationSelect
                            value={troubleshootForm.location}
                            onChange={(e) => updateTroubleshootForm("location", e.target.value)}
                            manualValue={troubleshootForm.manualLocation}
                            onManualChange={(e) =>
                              updateTroubleshootForm("manualLocation", e.target.value)
                            }
                            required
                          />
                          <TroubleshootCauseSelect
                            locationId={troubleshootForm.location}
                            value={troubleshootForm.cause}
                            onChange={(e) => updateTroubleshootForm("cause", e.target.value)}
                            manualValue={troubleshootForm.manualCause}
                            onManualChange={(e) =>
                              updateTroubleshootForm("manualCause", e.target.value)
                            }
                            required
                            disabled={!troubleshootForm.location}
                          />
                          <TroubleshootResolutionSelect
                            causeId={troubleshootForm.cause}
                            value={troubleshootForm.resolution}
                            onChange={(e) => updateTroubleshootForm("resolution", e.target.value)}
                            manualValue={troubleshootForm.manualResolution}
                            onManualChange={(e) =>
                              updateTroubleshootForm("manualResolution", e.target.value)
                            }
                            required
                            disabled={!troubleshootForm.cause}
                          />
                        </div>
                      </div>
                    </div>
                  ) : null}
                  <div className="row">
                    {attachments.map((attach, index) => (
                      <div className="col-lg-4 col-6">
                        <div className="form-group mb-4" key={index}>
                          <label>{attach.name}</label>
                          <ResponsiveImageUploader
                            image={attach.attachment_url}
                            type={attach.type}
                            onChangeImg={(type, image_url) => onChangeImg(type, image_url, index)}
                          />
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="form-group">
                    {(hasAccess("update-ticket") || hasAccess("update-customer-crm-ticket")) && (
                      <div className="d-flex justify-content-end">
                        <button
                          type="button"
                          onClick={() => handleClose()}
                          className="btn btn-secondary mr-1"
                        >
                          Batal
                        </button>
                        <button
                          type="submit"
                          className="btn btn-primary"
                          disabled={loading || data.status === "closed"}
                        >
                          {loading ? "Menyimpan ... " : "Update Proses"}
                        </button>
                      </div>
                    )}
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <h5>Detail Proses Tiket</h5>
            <ul className="ticket-progress-list mb-3">
              {data.ticket_details?.map((detail, index) => (
                <li className="ticket-progress-item py-3" key={index}>
                  <div className="d-flex align-items-center text-sm" style={{ gap: "10px" }}>
                    {detail.status === "open" && (
                      <span className="badge badge-success">{detail.status}</span>
                    )}
                    {detail.status === "unresolved" && (
                      <span className="badge badge-warning">{detail.status}</span>
                    )}
                    {detail.status === "resolved" && (
                      <span className="badge badge-secondary">{detail.status}</span>
                    )}

                    <span className="text-sm mx-1">
                      <i className="fa fa-user"></i> {detail.worked_by || "-"}
                    </span>
                    <span className="text-sm mx-1">
                      <i className="far fa-clock"></i>{" "}
                      {moment.unix(detail.createdAt).format("DD MMM YYYY - HH:mm")}
                    </span>
                  </div>

                  <span className="d-block my-2">
                    <span className="text-sm text-muted font-weight-bold">Deskripsi:</span> <br />
                    {detail.description}
                  </span>
                  <span className="d-block my-2">
                    <span className="text-sm text-muted font-weight-bold">Penugasan ke:</span>{" "}
                    <br />
                    {ROLE_ASSIGN_TICKET[detail.role] || "-"}
                  </span>
                  {detail.attachments.length > 0 && (
                    <>
                      <span className="text-sm text-muted font-weight-bold">Lampiran:</span> <br />
                      <div className="d-flex flex-wrap" style={{ gap: "10px" }}>
                        {detail.attachments.map((attach, index) => (
                          <a
                            className="d-block"
                            href={attach.attachment_url}
                            target="_blank"
                            rel="noreferrer"
                            key={index}
                          >
                            <img
                              src={attach.attachment_url}
                              alt={attach.type}
                              style={{ width: "100px" }}
                            />
                          </a>
                        ))}
                      </div>
                    </>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer></Modal.Footer>
    </Modal>
  );
}
